import type { KeyDef } from '../../types';

const numberRow: KeyDef[] = [
  { char: '§', label: '§', finger: 'L5', row: 'number' },
  { char: '1', shift: '!', finger: 'L5', row: 'number' },
  { char: '2', shift: '"', finger: 'L4', row: 'number' },
  { char: '3', shift: '#', finger: 'L3', row: 'number' },
  { char: '4', shift: '¤', finger: 'L2', row: 'number' },
  { char: '5', shift: '%', finger: 'L2', row: 'number' },
  { char: '6', shift: '&', finger: 'R1', row: 'number' },
  { char: '7', shift: '/', finger: 'R1', row: 'number' },
  { char: '8', shift: '(', finger: 'R3', row: 'number' },
  { char: '9', shift: ')', finger: 'R4', row: 'number' },
  { char: '0', shift: '=', finger: 'R5', row: 'number' },
  { char: '+', shift: '?', finger: 'R5', row: 'number' },
  { char: '´', shift: '`', finger: 'R5', row: 'number' },
  { char: '', label: '⌫', finger: 'R5', row: 'number', width: 1.6, decorative: true },
];

const topRow: KeyDef[] = [
  { char: '', label: 'Tab', finger: 'L5', row: 'top', width: 1.4, decorative: true },
  { char: 'q', finger: 'L5', row: 'top' },
  { char: 'w', finger: 'L4', row: 'top' },
  { char: 'e', finger: 'L3', row: 'top' },
  { char: 'r', finger: 'L2', row: 'top' },
  { char: 't', finger: 'L2', row: 'top' },
  { char: 'y', finger: 'R1', row: 'top' },
  { char: 'u', finger: 'R1', row: 'top' },
  { char: 'i', finger: 'R3', row: 'top' },
  { char: 'o', finger: 'R4', row: 'top' },
  { char: 'p', finger: 'R5', row: 'top' },
  { char: 'å', finger: 'R5', row: 'top' },
  { char: '¨', shift: '^', finger: 'R5', row: 'top' },
];

const homeRow: KeyDef[] = [
  { char: '', label: 'Caps', finger: 'L5', row: 'home', width: 1.6, decorative: true },
  { char: 'a', finger: 'L5', row: 'home' },
  { char: 's', finger: 'L4', row: 'home' },
  { char: 'd', finger: 'L3', row: 'home' },
  { char: 'f', finger: 'L2', row: 'home' },
  { char: 'g', finger: 'L2', row: 'home' },
  { char: 'h', finger: 'R1', row: 'home' },
  { char: 'j', finger: 'R1', row: 'home' },
  { char: 'k', finger: 'R3', row: 'home' },
  { char: 'l', finger: 'R4', row: 'home' },
  { char: 'æ', finger: 'R5', row: 'home' },
  { char: 'ø', finger: 'R5', row: 'home' },
  { char: '', label: '⏎', finger: 'R5', row: 'home', width: 1.6, decorative: true },
];

const bottomRow: KeyDef[] = [
  { char: '', label: '⇧', finger: 'L5', row: 'bottom', width: 1.4, decorative: true },
  { char: '<', shift: '>', finger: 'L5', row: 'bottom' },
  { char: 'z', finger: 'L5', row: 'bottom' },
  { char: 'x', finger: 'L4', row: 'bottom' },
  { char: 'c', finger: 'L3', row: 'bottom' },
  { char: 'v', finger: 'L2', row: 'bottom' },
  { char: 'b', finger: 'L2', row: 'bottom' },
  { char: 'n', finger: 'R1', row: 'bottom' },
  { char: 'm', finger: 'R1', row: 'bottom' },
  { char: ',', shift: ';', finger: 'R3', row: 'bottom' },
  { char: '.', shift: ':', finger: 'R4', row: 'bottom' },
  { char: '-', shift: '_', finger: 'R5', row: 'bottom' },
  { char: '', label: '⇧', finger: 'R5', row: 'bottom', width: 1.8, decorative: true },
];

const spaceRow: KeyDef[] = [
  { char: '', label: 'fn', finger: 'L5', row: 'space', decorative: true },
  { char: '', label: '⌃', finger: 'L5', row: 'space', decorative: true },
  { char: '', label: '⌥', finger: 'L4', row: 'space', decorative: true },
  { char: '', label: '⌘', finger: 'L2', row: 'space', width: 1.3, decorative: true },
  { char: ' ', label: '', finger: 'thumb', row: 'space', width: 6 },
  { char: '', label: '⌘', finger: 'R2', row: 'space', width: 1.3, decorative: true },
  { char: '', label: '⌥', finger: 'R4', row: 'space', decorative: true },
];

export const MAC_DK_LAYOUT: KeyDef[][] = [
  numberRow,
  topRow,
  homeRow,
  bottomRow,
  spaceRow,
];
